import { render, staticRenderFns } from "./MysteryBoxes.vue?vue&type=template&id=2851e963&scoped=true&"
import script from "./MysteryBoxes.vue?vue&type=script&lang=js&"
export * from "./MysteryBoxes.vue?vue&type=script&lang=js&"
import style0 from "./MysteryBoxes.vue?vue&type=style&index=0&id=2851e963&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2851e963",
  null
  
)

export default component.exports